// extracted by mini-css-extract-plugin
export default {"full-screen-button":"full-screen-button_full-screen-button__JqKPp"};